import { auth0Audience } from 'constants/config';
import { CredentialType } from 'types/api.types';
import type { OidcTokenFormat } from 'types/api.types';

// Mirrors `oidcTypeToV2Audience` in configuration-service credential-schema.ts.
// Kept as a frontend constant for display; values must stay in sync with the backend allowlist.
const oidcTypeToV2Audience: Partial<Record<CredentialType, string>> = {
  [CredentialType.AWS_OIDC]: 'sts.amazonaws.com',
  [CredentialType.AZURE_OIDC]: 'api://AzureADTokenExchange',
  [CredentialType.GCP_OIDC]: 'api://env0-gcp',
  [CredentialType.VAULT_OIDC]: 'api://env0-vault'
};

export const getOidcAudience = (type: CredentialType, tokenFormat?: OidcTokenFormat): string =>
  tokenFormat === 'v2' ? (oidcTypeToV2Audience[type] ?? auth0Audience) : auth0Audience;
